import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASFilterBox from "../../../../../components/FilterBox/FASFilter/FASFilter";
import { FiMenu } from "react-icons/fi";
import { format } from "date-fns";


import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import FASTable from "../../../../../components/Tables/FASTable";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import FASDroupdownFilterBox from "../../../../../components/FilterBox/FASFilter/FASDropDownFilter";
import {
  PurchaseAcList,
  PurchaseAnalysisCombination,
  PurchaseBookList,
  PurchaseItemList,
  PurchaseSubBook,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Purchase/PurchaseSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import FASCalender from "../../../../../components/Calendar/FASCalender";

export const PartyWiseItemWisePurchase = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const {
    PurchaseBookListdata,
    PurchaseAcListtdata,
    PurchaseSubBookdata,
    PurchaseItemListdata,
    PurchaseAnalysisCombinationdata,
  } = useSelector((state) => state.PurchaseSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const FinancialYear = Cookies.get("FinancialYear");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const [filters, setFilters] = useState({
    month: [],
    purchaseBook: [],
    account: [],
    subBook: [],
    items: [],
  });
  const [search, setSearch] = useState({
    month: "",
    purchaseBook: "",
    account: "",
    subBook: "",
    items: "",
  });

  const [selectedPurchaseBook, setSelectedPurchaseBook] = useState("");
  const [selectedPurchaseBookId, setSelectedPurchaseBookId] = useState([]);

  const [selectedAccountName, setSelectedAccountName] = useState("");
  const [selectedAccountNameId, setSelectedAccountNameId] = useState([]);

  const [selectedSubBook, setSelectedSubBook] = useState("");
  const [selectedSubBookId, setSelectedSubBookId] = useState([]);

  const [selectedItem, setSelectedItem] = useState("");
  const [selectedItemId, setSelectedItemId] = useState([]);

  const [activeTable, setActiveTable] = useState("ItemMonth");

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(PurchaseBookList({ Firm, Year: YearId }));
    dispatch(PurchaseAcList({ Firm, Year: YearId }));
    dispatch(PurchaseSubBook({ Firm, Year: YearId }));
    dispatch(PurchaseItemList({ Firm, Year: YearId }));
    dispatch(
      PurchaseAnalysisCombination({
        Firm,
        Year: YearId,
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      }),
    );
  }, [dispatch, Firm, YearId, endDate, startDate]);

  const purchaseAccountList =
    PurchaseAcListtdata?.Dtl?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];
  const purchaseBookList =
    PurchaseBookListdata?.Dtl?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];

  const purchaseSubBookList =
    PurchaseSubBookdata?.Dtl?.map((item) => ({
      label: item?.SubBookName,
      value: item?.SubBookId,
    })) || [];

  const purchaseItemList =
    PurchaseItemListdata?.ItemName?.map((item) => ({
      label: item?.ItemName,
      value: item?.ItemID,
    })) || [];

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = Array.isArray(prev[type]) ? prev[type] : [];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const applyFilter = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,

        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),

        BookIDs: (filters.purchaseBook || []).join(","),
        selectSalepartyIds: (filters.account || []).join(","),
        selecteSubBookdIds: (filters.subBook || []).join(","),
        selectItemIds: (filters.items || []).join(","),
      };

      await dispatch(PurchaseAnalysisCombination(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };

  const applyFilter1 = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,

        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),

        BookIDs: selectedPurchaseBookId?.toString() || "",
        selectSalepartyIds: selectedAccountNameId?.toString() || "",
        selecteSubBookdIds: selectedSubBookId?.toString() || "",
        selectItemIds: selectedItemId?.toString() || "",
      };

      await dispatch(PurchaseAnalysisCombination(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };

  const cardWrapStyle = {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
    backgroundColor:
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
  };

  const headerStyle = {
    backgroundColor:
      isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
    color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
    padding: "14px",
    margin: 0,
  };

  const PartyiteamwiseMeterepurchaseRow = () => {
    return (
      PurchaseAnalysisCombinationdata?.PartyDtl?.map((item, index) => ({
        srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const PartyiteamwiseMeterepurchaseColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
    { label: "Amount", key: "NetAmount", align: "right", format: "true" },
  ];

  const IteamwisePartywiseMeterepurchaseRow = () => {
    return (
      PurchaseAnalysisCombinationdata?.MonthDtl?.map((item, index) => ({
        srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const IteamwisePartywiseMeterepurchaseColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
    { label: "Net Amount", key: "NetAmount", align: "right", format: "true" },
  ];

  const IteamwiseMonthwiseMeterepurchaseRow = () => {
    return (
      PurchaseAnalysisCombinationdata?.PartyMonthDtl?.map((item, index) => ({
        // srNumber: index + 1,
        chart: true,
        ItemName: item.ItemName,
        NetAmount: item.NetAmount,
        AprAmt: item.AprAmt,
        MayAmt: item.MayAmt,
        JunAmt: item.JunAmt,
        JulAmt: item.JulAmt,
        AugAmt: item.AugAmt,
        SepAmt: item.SepAmt,
        OctAmt: item.OctAmt,
        NovAmt: item.NovAmt,
        DecAmt: item.DecAmt,
        JanAmt: item.JanAmt,
        FebAmt: item.FebAmt,
        MarAmt: item.MarAmt,
      })) || []
    );
  };

  const IteamwiseMonthwiseMeterepurchaseColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Total Amount",
      key: "NetAmount",
      align: "right",
      format: "true",
    },
    {
      label: "April",
      key: "AprAmt",
      align: "right",
      format: "true",
    },
    { label: "May", key: "MayAmt", align: "right", format: "true" },
    { label: "June", key: "JunAmt", align: "right", format: "true" },
    { label: "July", key: "JulAmt", align: "right", format: "true" },
    {
      label: "August",
      key: "AugAmt",
      align: "right",
      format: "true",
    },
    {
      label: "September",
      key: "SepAmt",
      align: "right",
      format: "true",
    },
    {
      label: "October",
      key: "OctAmt",
      align: "right",
      format: "true",
    },
    {
      label: "November",
      key: "NovAmt",
      align: "right",
      format: "true",
    },
    {
      label: "December",
      key: "DecAmt",
      align: "right",
      format: "true",
    },
    {
      label: "January",
      key: "JanAmt",
      align: "right",
      format: "true",
    },
    {
      label: "February",
      key: "FebAmt",
      align: "right",
      format: "true",
    },
    {
      label: "March",
      key: "MarAmt",
      align: "right",
      format: "true",
    },
  ];

  const isLoading =
    !PurchaseAnalysisCombinationdata ||
    !PurchaseAcListtdata ||
    !PurchaseBookListdata ||
    !PurchaseSubBookdata ||
    !PurchaseItemListdata ||
    isFilterLoading;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Purchase Books */}
            <FASFilterBox
              title="Purchase Books"
              items={purchaseBookList}
              search={search.purchaseBook || ""}
              setSearch={(val) => handleSearch("purchaseBook", val)}
              selectedItems={filters.purchaseBook || []}
              toggleItem={(item) => toggleItem("purchaseBook", item)}
              selectAll={() => selectAll("purchaseBook", purchaseBookList)}
            />

            {/* Accounts */}
            <FASFilterBox
              title="Accounts"
              items={purchaseAccountList}
              search={search.account || ""}
              setSearch={(val) => handleSearch("account", val)} // ✅ FIXED
              selectedItems={filters.account || []}
              toggleItem={(item) => toggleItem("account", item)}
              selectAll={() => selectAll("account", purchaseAccountList)}
            />

            {/* Sub Books */}
            <FASFilterBox
              title="Sub Books"
              items={purchaseSubBookList}
              search={search.subBook || ""}
              setSearch={(val) => handleSearch("subBook", val)}
              selectedItems={filters.subBook || []}
              toggleItem={(item) => toggleItem("subBook", item)}
              selectAll={() => selectAll("subBook", purchaseSubBookList)}
            />

            {/* Items */}
            <FASFilterBox
              title="Items"
              items={purchaseItemList}
              search={search.items || ""}
              setSearch={(val) => handleSearch("items", val)}
              selectedItems={filters.items || []}
              toggleItem={(item) => toggleItem("items", item)}
              selectAll={() => selectAll("items", purchaseItemList)}
            />

            {/* Apply Button */}
            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="">
        {/* DESKTOP FILTER */}
        <div style={{ padding: "10px" }}>
          <div
            className="d-none d-lg-block"
            style={{
              marginBottom: "10px",
              padding: "12px",
              borderRadius: "12px",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
              border: `1px solid ${
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
              }`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Row className="g-3">
              {/* Row 1 */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Purchase Books"
                  placeholder="Select Purchase Books"
                  data={purchaseBookList}
                  selectedValue={selectedPurchaseBook}
                  setSelectedValue={setSelectedPurchaseBook}
                  selectedId={selectedPurchaseBookId}
                  setSelectedId={setSelectedPurchaseBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Accounts"
                  placeholder="Select Accounts"
                  data={purchaseAccountList}
                  selectedValue={selectedAccountName}
                  setSelectedValue={setSelectedAccountName}
                  selectedId={selectedAccountNameId}
                  setSelectedId={setSelectedAccountNameId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Row 2 */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sub Books"
                  placeholder="Select Sub Book"
                  data={purchaseSubBookList}
                  selectedValue={selectedSubBook}
                  setSelectedValue={setSelectedSubBook}
                  selectedId={selectedSubBookId}
                  setSelectedId={setSelectedSubBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Items"
                  placeholder="Select Item"
                  data={purchaseItemList}
                  selectedValue={selectedItem}
                  setSelectedValue={setSelectedItem}
                  selectedId={selectedItemId}
                  setSelectedId={setSelectedItemId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Row 3 */}
              <Col xl={12} lg={12} md={12} sm={12}>
                <Button
                  onClick={applyFilter1}
                  style={{
                    width: "100%",
                    height: "44px",
                    borderRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    border: "none",
                    fontWeight: "600",
                  }}
                  className="common-hover-btn"
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </div>
        </div>

        <Col xl={12} lg={12} md={12}>
          <Row className="g-3 align-items-start">
            <div style={{ marginTop: "20px" }}>
              <div style={cardWrapStyle}>
                <div style={headerStyle}>
                  <h5
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    ITEMWISE MONTHWISE METER PURCHASE
                  </h5>
                </div>

                <FASTable
                  data={IteamwiseMonthwiseMeterepurchaseRow()}
                  columns={IteamwiseMonthwiseMeterepurchaseColumns}
                />
              </div>
            </div>
            <Col xs={12}>
              {/* ✅ BUTTONS */}
              <div
                style={{ display: "flex", gap: "12px", marginBottom: "12px" }}
              >
                {[
                  {
                    key: "ItemMonth",
                    label: "PartyWise ItemWise Meter Purchase",
                  },
                  {
                    key: "ParentChild",
                    label: "ItemWise PartyWise Meter Purchase",
                  },
                ].map((btn) => (
                  <button
                    key={btn.key}
                    onClick={() => setActiveTable(btn.key)}
                    style={{
                      flex: 1,
                      height: "52px",
                      borderRadius: "14px",
                      cursor: "pointer",
                      fontWeight: "600",
                      border: `2px solid ${
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                      }`,
                      background:
                        activeTable === btn.key
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                      color:
                        activeTable === btn.key
                          ? isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1
                          : isdark === "light"
                            ? iscolour?.Colour12
                            : iscolourDark?.Colour11,
                    }}
                  >
                    {btn.label}
                  </button>
                ))}
              </div>

              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                  marginTop: "10px",
                }}
              >
                {/* ✅ HEADING */}
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    padding: "14px",
                  }}
                >
                  <h5
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    {activeTable === "ItemMonth"
                      ? "PARTYWISE ITEMWISE METER PURCHASE"
                      : "ITEMWISE PARTYWISE METER PURCHASE"}
                  </h5>
                </div>

                {/* ✅ TABLE */}
                <div
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                  }}
                >
                  {activeTable === "ItemMonth" ? (
                    <FASParentChild
                      data={PartyiteamwiseMeterepurchaseRow()}
                      columns={PartyiteamwiseMeterepurchaseColumns}
                      parentKey="AcName"
                      childKey="ItemName"
                    />
                  ) : (
                    <FASParentChild
                      data={IteamwisePartywiseMeterepurchaseRow()}
                      columns={IteamwisePartywiseMeterepurchaseColumns}
                      parentKey="ItemName"
                      childKey="AcName"
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>

          {/* BOTTOM TABLE */}
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
